const PLANS = [
  {
    label: "Free",
    id: "free",
    price: 0,
  },
  // {
  //   label: "Demo",
  //   id: "demo",
  //   price: 0,
  // },
  {
    label: "Starter",
    id: "basic",
    price: 15,
    aiCredits: 30000,
    canBuy: true,
  },
  {
    label: "Pro",
    id: "premium",
    price: 25,
    aiCredits: 100000,
    canBuy: true,
  },
  {
    label: "Business",
    id: "enterprise",
    price: 59,
    aiCredits: 250000,
    canBuy: true,
  },
  {
    label: "Saaszilla - Tier 1",
    id: "saaszilla-1",
    price: 49,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 2",
    id: "saaszilla-2",
    price: 99,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 3",
    id: "saaszilla-3",
    price: 299,
    lifetime: true,
  },
  {
    label: "Saaszilla - Tier 4",
    id: "saaszilla-4",
    price: 599,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 1",
    id: "appsumo-1",
    price: 59,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 2",
    id: "appsumo-2",
    price: 119,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 3",
    id: "appsumo-3",
    price: 299,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 4",
    id: "appsumo-4",
    price: 599,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 5",
    id: "appsumo-5",
    price: 999,
    lifetime: true,
  },
  // August 2026 AppSumo campaign. Customers see plain "Appsumo - Tier N"
  // everywhere in the app; the campaign suffix exists only here so support
  // cannot pick the wrong tier out of the admin plan list — the two campaigns
  // carry different website / lead / pageview limits.
  {
    label: "Appsumo - Tier 1 (Aug 2026)",
    id: "appsumo-aug26-1",
    price: 69,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 2 (Aug 2026)",
    id: "appsumo-aug26-2",
    price: 139,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 3 (Aug 2026)",
    id: "appsumo-aug26-3",
    price: 349,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 4 (Aug 2026)",
    id: "appsumo-aug26-4",
    price: 799,
    lifetime: true,
  },
  {
    label: "Appsumo - Tier 5 (Aug 2026)",
    id: "appsumo-aug26-5",
    price: 1299,
    lifetime: true,
  },
  {
    label: "Whitelabel",
    id: "whitelabel",
    price: 199,
    lifetime: false,
  },
];


module.exports = {
  PLANS,
};
